//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;

//bootstrapのmodalを読み込み
// import "/node_modules/bootstrap/js/dist/modal";

import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function () {
  // .header-nav--icon をクリックしたとき
  $(".header-nav--icon").on("click", function () {
    $(".sp-nav").addClass("open"); // .sp-navに.openクラスを追加
  });

  // .sp-nav-close をクリックしたとき
  $(".sp-nav-close").on("click", function () {
    $(".sp-nav").removeClass("open"); // .sp-navから.openクラスを削除
  });

  // .sp-navに.openがある状態で、.sp-nav-listのアンカーリンクをクリックしたとき
  $(document).on("click", ".sp-nav.open .sp-nav-list a", function () {
    $(".sp-nav").removeClass("open"); // .sp-navから.openクラスを削除
  });

  // スクロール量のしきい値を設定（この場合、100ピクセル）
  var scrollThreshold = 1000;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > scrollThreshold) {
      $(".header").addClass("bg-color");
    } else {
      $(".header").removeClass("bg-color");
    }
  });

  // 現在のウェブサイトのドメインを取得
  var siteDomain = window.location.hostname;

  // 全ての<a>タグをループしてチェック
  $("a[href^=\"http://\"], a[href^=\"https://\"]").each(function () {
    var linkDomain = new URL($(this).attr("href")).hostname;
    // リンクが外部のものだった場合に target="_blank" を追加
    if (linkDomain !== siteDomain) {
      $(this).attr("target", "_blank");
    }
  });

  //画面の表示領域にはいったら表示させる
  $(window).on("scroll", function() {
    $(".box_fade").each(function() {
      var position = $(this).offset().top;  // 要素のページ上部からの位置
      var scroll = $(window).scrollTop();   // スクロール位置
      var windowHeight = $(window).height();  // ウィンドウの高さ

      if (scroll > position - windowHeight + 100 + 100) {
        $(this).css("opacity", "1");
        $(this).css("transform", "translateY(0)");
      }
    });
  });

  //スライド
  var swiper = new Swiper(".interview-slide", {
    spaceBetween: 24,
    centeredSlides: true,
    slidesPerView: 1.3,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });
});

